import React from "react";
import { getZscalerURLParams } from "./../utilities/utilities";
import AttentionMessage from "../components/attention-message";
import Details from "./../components/details";
import Disclaimer from "./../components/disclaimer";
import Header from "../components/header";
import SafetyNotice from "./../safety-notice";
import ContinueButton from "../components/continue-button";
import config from "../config";

const CoachLitePage = (props) => {
  const params = getZscalerURLParams();
  return (
    <div className="main fade-up">
      <Header content="You are leaving Trinity Health protected space" />
      <AttentionMessage
        content={`The site you are accessing is outside of the boundaries of Trinity
        Health protections, identified as: ${params.category}`}
      />

      <div className="content fade-in">
        <div className="exception-description">
          <p>
            Colleagues should use Trinity Health provided applications such as
            Microsoft Outlook and Sharepoint.
          </p>
          <p>
            Please be conscious of Trinity Health protected data such as{" "}
            <strong>
              Protected Health Information and Personal Identifiable
              Information.
            </strong>
          </p>
          <p>
            If you have questions about what information is appropriate to share
            using this site please email{" "}
            <a
              id="askCyberSecurityLink"
              href={`mailto:${config.emailAddress}`}
              target="_blank"
            >
              AskCyberSecurity@trinity-health.org
            </a>
            . This is a courtesy message to remind you that we all have a
            responsibility to protect patient data. You may continue to this
            site by clicking the button below:
          </p>
        </div>
        <div>
          <ContinueButton />
        </div>
        <Details />
        <SafetyNotice />
        <Disclaimer />
      </div>
    </div>
  );
};

export default CoachLitePage;
